import KeyMirror from 'keymirror'

/**
 * @enum
 */
export const PROVIDE_KEYS = KeyMirror({
  FINAL_DOC_LENGTH: null,
})

export const FORM_SRC_PROJECT_CONTROL = 'projectControl'
